// extracted by mini-css-extract-plugin
export default {"bgModalGrey":"NoData_bgModalGrey__1EnP0","bgModal":"NoData_bgModal__ajx28","messageIcon":"NoData_messageIcon__lgfci","backBtn":"NoData_backBtn__y9SC5"};